/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CheckInType,
  CheckInTypeOptional,
  CheckInTypeMetaI,
  CheckInTypeTrackedI,
} from "./check-in-type";
import { CheckInTypeTracked, CheckInTypeMeta } from "./check-in-type";

/**
 *
 * @export
 * @interface PersonCheckInBase
 */
export interface PersonCheckInBaseOptional {
  /**
   *
   * @type {CheckInType}
   * @memberof PersonCheckInBase
   */
  checkInType?: CheckInType;
  /**
   *
   * @type {string}
   * @memberof PersonCheckInBase
   */
  checkInTime?: Date;
}

export interface PersonCheckInBase extends PersonCheckInBaseOptional {
  /**
   *
   * @type {CheckInType}
   * @memberof PersonCheckInBase
   */
  checkInType: CheckInType;
  /**
   *
   * @type {string}
   * @memberof PersonCheckInBase
   */
  checkInTime: Date;
}

export interface PersonCheckInBaseTrackedI {
  /**
   *
   * @type {CheckInType}
   * @memberof PersonCheckInBase
   */
  checkInType?: CheckInType;
  checkInTypeIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof PersonCheckInBase
   */
  checkInTime?: Date;
  checkInTimeIsSet: boolean;
}

transformDatesMap.set("PersonCheckInBase", function (model: PersonCheckInBase) {
  if (typeof model.checkInTime == "string")
    model.checkInTime = new Date(model.checkInTime);
});

export type PersonCheckInBaseMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  checkInType: PropertyMeta<CheckInTypeMetaI>;
  //isDate: false
  //isDatetime: true
  checkInTime: PropertyMeta<MetaTypeBase<Date>>;
}>;

export var PersonCheckInBaseMeta: PersonCheckInBaseMetaI =
  {} as PersonCheckInBaseMetaI;
PersonCheckInBaseMeta = typeMeta("PersonCheckInBase", {
  checkInType: propertyMeta("checkInType", false, true, false, CheckInTypeMeta),
  checkInTime: propertyMeta(
    "checkInTime",
    false,
    true,
    false,
    MetaTypesBase.Date,
  ),
});

const metaI = PersonCheckInBaseMeta;

registerMeta(() => {});

export class PersonCheckInBaseTracked implements PersonCheckInBaseTrackedI {
  changeTracker: boolean = false;
  //isNew: boolean = false
  checkInType__I?: CheckInType = undefined;
  checkInTypeIsSet: boolean = false;
  set checkInType(v: undefined | CheckInType) {
    if (v !== undefined) {
      this.checkInType__I = v;
      this.checkInTypeIsSet = true;
    } else {
      this.checkInType__I = v || undefined;
      this.checkInTypeIsSet = true;
    }
    this.changeTracker = true;
  }
  get checkInType() {
    return this.checkInType__I;
  }
  checkInTime__I?: Date = undefined;
  checkInTimeIsSet: boolean = false;
  set checkInTime(v: undefined | Date) {
    if (v !== undefined) {
      this.checkInTime__I = v;
      this.checkInTimeIsSet = true;
    } else {
      this.checkInTime__I = v || undefined;
      this.checkInTimeIsSet = true;
    }
    this.changeTracker = true;
  }
  get checkInTime() {
    return this.checkInTime__I;
  }
  constructor(config?: PersonCheckInBaseOptional, options?: AssignOptions) {
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    return this == other;
  }
  setIds() {}
  assignFrom(
    config: PersonCheckInBaseOptional,
    options?: AssignOptions,
  ): PersonCheckInBaseTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (
      config.checkInType &&
      this.checkInTypeApplyFilter(optionsRequired.filter)
    ) {
      this.checkInType = config.checkInType;
      if (optionsRequired.unassign) this.checkInTypeIsSet = false;
      else this.checkInTypeIsSet = true;
    }
    if (
      config.checkInTime &&
      this.checkInTimeApplyFilter(optionsRequired.filter)
    ) {
      this.checkInTime = config.checkInTime;
      if (optionsRequired.unassign) this.checkInTimeIsSet = false;
      else this.checkInTimeIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): PersonCheckInBaseTrackedI {
    const cloned = {} as PersonCheckInBaseTrackedI;
    if (
      this.checkInTypeIsSetDeep() &&
      this.checkInTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.checkInTypeIsSet = true;
      cloned.checkInType = this.checkInType;
    } else {
      //cloned.checkInTypeIsSet = false
    }
    if (
      this.checkInTimeIsSetDeep() &&
      this.checkInTimeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.checkInTimeIsSet = true;
      cloned.checkInTime = this.checkInTime;
    } else {
      //cloned.checkInTimeIsSet = false
    }
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): PersonCheckInBaseTrackedI {
    if (!this.checkInTypeApplyFilter(filter)) this.checkInTypeIsSet = false;

    if (!this.checkInTimeApplyFilter(filter)) this.checkInTimeIsSet = false;

    return this;
  }
  checkInTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonCheckInBaseMeta.checkInType,
      PersonCheckInBaseMeta,
      this.checkInType,
      this,
    );
  }
  checkInTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.checkInTypeIsSet && this.checkInTypeApplyFilter(filter))
      return true;

    return false;
  }
  checkInTimeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      PersonCheckInBaseMeta.checkInTime,
      PersonCheckInBaseMeta,
      this.checkInTime,
      this,
    );
  }
  checkInTimeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.checkInTimeIsSet && this.checkInTimeApplyFilter(filter))
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.checkInTypeIsSetDeep(filter)) return true;
    if (this.checkInTimeIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
